<template>
  <Container>
    <HeroText class="pt-20" title="This is awkward." subtitle="Unfortunately, we can't offer you internet at your address :(" />
  </Container>

  <div class="bg-white font-poppins mb-24">
    <Container>
      <Title class="mb-4" title="How can we help?" :centered="true" id="contact"/>
      <HelpOptions2 v-if="brandService.getName() === Brand.NEX" class="pb-20" :features="contacts"/>
    </Container>
  </div>
</template>

<script lang="ts" setup>
import Title from '../components/content/Title.vue';
import { Brand } from '../services/integration/enums';
import HeroText from '../components/content/HeroText.vue';
import Container from '../components/content/Container.vue';
import HelpOptions2 from '../components/content/HelpOptions2.vue';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const contacts = brandService.getContacts();

</script>
